export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const config = useRuntimeConfig();
    const usercentricsSettingsId = config.public.usercentrics?.settingsId;

    if (usercentricsSettingsId) {
      const scriptElement = document.createElement("script");
      scriptElement.id = "usercentrics-cmp";
      scriptElement.async = true;
      scriptElement.setAttribute("data-eu-mode", "true");
      scriptElement.setAttribute("data-settings-id", usercentricsSettingsId);
      scriptElement.src =
        "https://app.eu.usercentrics.eu/browser-ui/latest/loader.js";

      document.head.appendChild(scriptElement);
    }
  }
});
